
import Cookies from 'js-cookie'

export default {
  // 时间戳转时间格式
  formatDate(timestamp, type, is_timestamp) {
    if (timestamp === 0) return ''
    const date = new Date(timestamp * 1000)
    let year = ''
    if (is_timestamp) {
      year = new Date(timestamp).getFullYear()
    } else {
      year = date.getFullYear()
    }
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)
    const hours = ('0' + date.getHours()).slice(-2)
    const minutes = ('0' + date.getMinutes()).slice(-2)
    const seconds = ('0' + date.getSeconds()).slice(-2)
    if (type === 'YYYY-MM-DD') {
      return `${year}-${month}-${day}`
    } else if (type === 'YYYY年MM月DD日') {
      return `${year}年${month}月${day}日`
    } else if (type === 'YYYY') {
      return `${year}`
    } else if (type === 'MM') {
      return `${month}`
    } else {
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  },
  // 判断当前操作系统是 Windows、Mac、Linux
  detectOS(): 'windows' | 'mac' | 'linux' | 'unknown' {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.indexOf('win') !== -1) {
      return 'windows';
    }
    if (userAgent.indexOf('mac') !== -1) {
      return 'mac';
    }
    if (userAgent.indexOf('linux') !== -1) {
      return 'linux';
    }

    return 'unknown';
  },
  /**
   * 获取缓存
   *
   * @return   string
   **/
  getCache(key, type?) {
    var str = localStorage.getItem(key)
    if (str === 'undefined' || str === 'null') {
      return ''
    } else if (typeof type === 'undefined') {
      return str
    }
    return JSON.parse(str)
  },
  /**
   * 清除缓存
   *
   * @return   string
   **/
  removeCache(key) {
    return localStorage.removeItem(key)
  },
  /**
   * 设置缓存
   *
   * @return   string
   **/
  setCache(key, value) {
    if (this.getCache(key)) {
      this.removeCache(key)
    }

    if (typeof value === 'object') {
      localStorage.setItem(key, JSON.stringify(value))
    } else if (typeof value === 'string') {
      localStorage.setItem(key, value)
    } else {
      localStorage.setItem(key, value)
    }

    return true
  },
  // 复制内容，html转文本并保留格式
  copyText(text:string) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';  // 防止页面滚动
    document.body.appendChild(textarea);
    textarea.select();
   
    try {
      const successful = document.execCommand('copy');
      const msg = successful ? '成功' : '失败';
      console.log('复制' + msg);
      return successful;
    } catch (err) {
      console.error('无法复制文本: ', err);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  },
  // 新打开浏览器标签页展示老科服网路径
  openUrl(type: string, url: string) {

    // 区分美吉、桑格
    const {
      VITE_APP_MJ_KF_ORIGIN,
      VITE_APP_MJ_CLOUD_ORIGIN,
      VITE_APP_SG_KF_ORIGIN,
      VITE_APP_SG_CLOUD_ORIGIN,
    } = import.meta.env

    let kfOrigin = ''
    let cloudOrigin = ''

    if (this.getWebName() === 'mj') {
      kfOrigin = VITE_APP_MJ_KF_ORIGIN
      cloudOrigin = VITE_APP_MJ_CLOUD_ORIGIN
    } else if (this.getWebName() === 'sg') {
      kfOrigin = VITE_APP_SG_KF_ORIGIN
      cloudOrigin = VITE_APP_SG_CLOUD_ORIGIN
    }
    
    if (type === 'cloud') { // 跳老云平台
      window.open(`${cloudOrigin}/web/${url}`, '_blank')
    } else if (type === 'kf') {  // 跳老科服网
      window.open(`${kfOrigin}/web/${url}`, '_blank')
    }
  },
  // 唤醒美吉网盘、桑格网盘客户端
  openPanMajorbio(row: any) {
    let { dataType,fsId, fileName } = row // dataType：左侧菜单的数据类型
    let userInfo = this.getCache('user')
    const { sso_id } = JSON.parse(userInfo) 
    let sso = Cookies.get('sso')
    // 加载当前模式下的环境变量
    const NODE_ENV = import.meta.env.VITE_APP_ENV
    let protocal =''
    if (NODE_ENV !== 'production') { // 非生产环境
      if (this.getWebName() === 'mj') {
        protocal = `pan.majorbio.test://download?data_type=${dataType}&sso_id=${sso_id}&sso=${sso}&id=${fsId}&name=${fileName}`
      } else if (this.getWebName() === 'sg') {
        protocal = `pan.sanger.test://download?data_type=${dataType}&sso_id=${sso_id}&sso=${sso}&id=${fsId}&name=${fileName}`
      } else { // 兜底，万一有缓存了呢 
        protocal = `pan.majorbio.test://download?data_type=${dataType}&sso_id=${sso_id}&sso=${sso}&id=${fsId}&name=${fileName}`
      }
    } else { // 生产环境
      if (this.getWebName() === 'mj') {
        protocal =  `pan.majorbio://download?data_type=${dataType}&sso_id=${sso_id}&sso=${sso}&id=${fsId}&name=${fileName}`
      } else if (this.getWebName() === 'sg') {
        protocal =  `pan.sanger://download?data_type=${dataType}&sso_id=${sso_id}&sso=${sso}&id=${fsId}&name=${fileName}`
      } else { // 兜底，万一有缓存了呢 
        protocal =  `pan.majorbio://download?data_type=${dataType}&sso_id=${sso_id}&sso=${sso}&id=${fsId}&name=${fileName}`
      }
    }
    
    window.protocolCheck(protocal, () => {
      let message = ''
      // 区分美吉、桑格
      if (this.getWebName() === 'mj') {
        message = '您暂未安装美吉网盘客户端！'
      } else if (this.getWebName() === 'sg') {
        message = '您暂未安装桑格网盘客户端！'
      }
      // 成功回调
      ElMessageBox.alert(message, '温馨提示', {
        // if you want to disable its autofocus
        // autofocus: false,
        confirmButtonText: '现在安装',
        callback: () => {
          window.open('/project-center/download')
        }
      })
    })
  },
  // 系统的chrome标签页设置小红点
  setFaviconWithBadge() {
    
    const canvas = document.createElement('canvas');
    canvas.width = 16;
    canvas.height = 16;
    const ctx = canvas.getContext('2d');

    // 加载原始 favicon
    const img = new Image();
    img.src = '../../public/favicon.ico';
    img.onload = () => {
      ctx.drawImage(img, 0, 0);

      // 绘制小红点
      ctx.fillStyle = '#f00';
      ctx.beginPath();
      ctx.arc(12, 4, 3, 0, 2 * Math.PI);
      ctx.fill();

      // 设置新的 favicon
      const favicon = document.getElementById('favicon');
      favicon.href = canvas.toDataURL('image/png');
    };
  },
  //文件url下载，解决跨域
  downloadFile(url, fileName) {
    if (!url) return
    var x = new XMLHttpRequest()
    x.open('GET', url, true)
    x.responseType = 'blob'
    x.onload = function (e) {
      var url = window.URL.createObjectURL(x.response)
      var a = document.createElement('a')
      a.href = url
      a.download = fileName
      a.click()
    }
    x.send()
  },
  // 根据邮箱判断是否是内部用户
  isInnerUser(email:string) {
    if (email && email.indexOf('@majorbio.com') !== -1) { // 美吉内部用户
      return true 
    } else { // 外部用户
      return false
    }
  },
  // 判断字符串是否是超链接
  isUrl(str:string) {
    // 正则表达式用于匹配常见的URL模式
    const urlPattern = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z]{2,6})([\/\w\.-]*)*\/?$/;
    return urlPattern.test(str);
  },
  getWebName() {
    if (
      window.location.origin.indexOf(import.meta.env.VITE_APP_NEW_MJ_KF_ORIGIN) !==
      -1
    ) {
      return 'mj'
    } else if (
      window.location.origin.indexOf(import.meta.env.VITE_APP_NEW_SG_KF_ORIGIN) !==
      -1
    ) {
      return 'sg'
    } else if (
      window.location.origin.indexOf('localhost') !==
      -1
    ) {
      return 'local'
    } 
  },
  loadScript(url, callback) {
    var script = document.createElement('script');
    script.src = url;
    script.onload = function() {
      if (typeof callback === 'function') {
        callback();
      }
    };
    script.onerror = function() {
      console.error('脚本加载失败: ' + url);
    };
    document.head.appendChild(script);
  },
  // 对象参数的字符串序列变化
  paramsToString(obj: any) { 
    // 创建 URLSearchParams 对象
    const params = new URLSearchParams();

    // 添加参数
    Object.entries(obj).forEach(([key, value]) => {
      params.append(key, value);
    });
    return params.toString()
  },
  formatFileSize(bytes, decimals = 2) {
    if (bytes === 0) return '0BYTE';
  
    const k = 1024;
    const units = ['BYTE', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    console.log(i,units[i],(bytes / Math.pow(k, i)).toFixed(decimals),`${parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))}${units[i]}`)
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))}${units[i]}`
  },
   //数组去重
   uniqueFunc(arr, uniId) {
    //如果有uniId，则为数组对象
    if (uniId) {
      const res = new Map()
      return arr.filter((item) => !res.has(item[uniId]) && res.set(item[uniId], 1))
    } else {
      //数组元素
      return arr.filter((item, index, arr) => arr.indexOf(item) === index)
    }
  },
  // 延迟
  delay(ms:number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  },
  /**
 * 校验文件夹名称是否符合规则
 * @param {string} folderName 要校验的文件夹名称
 * @returns {boolean} 是否通过校验
 */
  validateFolderName(folderName:string) {
    // 规则1: 首尾不能有空字符，结尾不能为.号
    const trimmed = folderName.trim();
    if (trimmed !== folderName) {
        return {
            isValid: false,
            message: "文件夹名称首尾不能包含空格、制表符等空白字符"
        };
    }
    if (folderName.endsWith('.')) {
        return {
            isValid: false,
            message: "文件夹名称不能以.号结尾"
        };
    }

    // 规则2: 文件名和扩展名不能同时为空
    if (!folderName) {
        return {
            isValid: false,
            message: "文件夹名称不能为空"
        };
    }

    // 规则3: 文件名中不能包含\/:*?"<>|中的任意字符
    const invalidChars = /[\\/:*?"<>|]/;
    if (invalidChars.test(folderName)) {
        return {
            isValid: false,
            message: "文件夹名称不能包含以下字符: \\ / : * ? \" < > |"
        };
    }

    // 规则4: 文件名(包括扩展名)的长度不得大于255个字符
    if (folderName.length > 255) {
        return {
            isValid: false,
            message: "文件夹名称长度不能超过255个字符"
        };
    }

    // 规则5: 文件名中不能出现除空格符外的任意空字符
    const whitespaceChars = /[\t\f\v\r\n]/;
    if (whitespaceChars.test(folderName)) {
        return {
            isValid: false,
            message: "文件夹名称不能包含制表符、换页符等空白字符"
        };
    }

    return {
        isValid: true,
        message: "文件夹名称有效"
    };
  }
}
